import React from 'react';
import "./MutualFund.css"


function Equity() {



  return (
    <>
    
    <div className='div_equity'>
    <div className='iframe'>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/IeRSr6F2NOM" title="YouTube video player"
     frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
     allowfullscreen>

     </iframe>
<div class="credit-container">
<p class="credit-text">
      Powered by <a class="credit-link" href="https://www.mutualfundssahihai.com/en/what-is-a-mutual-fund">Mutual Fund Sahi Hai</a></p>
</div>
</div>



       <div className='description' >
       
        <h2 className='Simplifying_equity'>
       What are Equity Funds?
        </h2>
      
     

        An Equity Fund is a Mutual Fund Scheme that invests predominantly in shares/stocks of companies. They are also known as Growth Funds.
        <br />
        <br />
        Equity Funds are either Active or Passive.  In an Active Fund, a fund manager scans the market, conducts research on companies, examines performance and looks for the best stocks to invest.
        <br />
        <br />
        In a Passive Fund, the fund manager builds a portfolio that mirrors a popular market index, say Sensex or Nifty Fifty.
        <br />
        <br/>
        Furthermore, Equity Funds can also be divided as per Market Capitalisation, i.e. how much the capital market values an entire company’s equity. There can be Large Cap, Mid Cap, Small or Micro Cap Funds.
        <br />
        <br />
        Also there can be a further classification as Diversified or Sectoral / Thematic. In the former, the scheme invests in stocks across the entire market spectrum, while in the latter it is restricted to only a particular sector or theme, say, Infotech or Infrastructure.
        <br />
        <br />
        Thus, an equity fund essentially invests in company shares, and aims to provide the benefit of professional management and diversification to ordinary investors.
        <br />
        <br />

        Equity funds can be categorized into two main types: active funds and passive funds. In an active fund, a skilled fund manager actively manages the fund by conducting market research, analyzing company performance, and selecting stocks that are expected to outperform the market. The fund manager's expertise and research play a crucial role in the fund's performance.
        <br />
        <br />
        On the other hand, passive funds, also known as index funds, aim to replicate the performance of a specific market index, such as the Sensex or Nifty Fifty. The fund manager builds a portfolio that mirrors the composition of the chosen index. Passive funds generally have lower expense ratios compared to active funds, as they require less active management.

</div>



</div>


    </>
);
}
export default Equity;